export default { sha: '5eef620b8d2245416dad4a9059f23f63c5ce098f', buildNumber: 'undefined' }
